/**
 * DevExtreme (esm/__internal/grids/data_grid/module_not_extended/master_detail.js)
 * Version: 25.1.6
 * Build date: Mon Oct 13 2025
 *
 * Copyright (c) 2012 - 2025 Developer Express Inc. ALL RIGHTS RESERVED
 * Read about DevExtreme licensing here: https://js.devexpress.com/Licensing/
 */
import { masterDetailModule } from "../../../grids/grid_core/master_detail/m_master_detail";
import gridCore from "../m_core";
gridCore.registerModule("masterDetail", masterDetailModule);